<template>
  <!-- new view -->
  <section class="blue register-page mobile-login-page">  
    <AllTheme />
    <div class="w-logo">
        <img :src="logo_file" alt="logo" class="w-input-fields animate__animated animate__fadeInUp animate__delay-1s" v-if="logo_file !== '' && logo_file !== null"/>
        <img src="../../assets/images/gamelab.svg" alt="logo" class="w-input-fields animate__animated animate__fadeInUp animate__delay-1s" v-if="logo_file == '' || logo_file == null"/>
    </div>
    <div class="w-form-block h-60 mt-5">

        <!-- buttons section with sso section -->
        <div class="main-action-box w-login-hide" v-if="remote_verified && ( is_restricted_freeplay || sso_active) && !is_logged_in">
            <template v-if="is_restricted_freeplay && sso_active">
                <div class="w-form-control animate__animated animate__fadeInUp animate__delay-2s">
                    <a :href="sso_urls.login + pod_id_key" target="_blank" class="flex-fill m-0" @click="sso_clicked ? $event.preventDefault() : (sso_clicked=true, handleModeTabsSwitch('ssoplay'))" :class="[(selected_button == 'ssoplay' ? 'active' : ''), sso_clicked ? 'sso-disabled' : '']" :disabled="sso_clicked">Play <b>Free</b> with {{ client_short_name }} Email</a>
                </div>
                <div class="w-form-control animate__animated animate__fadeInUp animate__delay-2s">
                    <button class="flex-fill" :class="[(selected_button == 'paytoplay' ? 'active' : '')]" @click="handleModeTabsSwitch('paytoplay')">No {{ client_short_name }} Email? <b>PAY-TO-PLAY</b></button>
                </div>
            </template>
            <template v-if="!is_restricted_freeplay && sso_active">
                <div class="w-form-control animate__animated animate__fadeInUp animate__delay-2s">
                    <a :href="sso_urls.login + pod_id_key" target="_blank" class="flex-fill" @click="sso_clicked ? $event.preventDefault() : sso_clicked=true" :class="[(selected_button == 'ssoplay' ? 'active' : ''), sso_clicked ? 'sso-disabled' : '']" :disabled="sso_clicked">Play <b>Free</b> with {{ client_short_name }} Credentials</a>
                </div>
            </template>
        </div>

        <!-- login form section -->
        <form action="" class="" @submit.stop.prevent 
        v-if="remote_verified && !is_logged_in && (!sso_active || (is_restricted_freeplay && sso_active && selected_button == 'paytoplay')) && ((is_paytoplay_login_active && (is_restricted_freeplay || sso_active)) || (!is_paytoplay_login_active && !is_restricted_freeplay && !sso_active))">
            <div class="w-form-control w-input-fields animate__animated animate__fadeInUp animate__delay-2s">
                <span><i class="fa-solid fa-user"></i></span>
                <input type="text" name="email" value="" v-model="username" placeholder="email@domain.com" autofocus/>
            </div>
            <div class="w-form-control w-input-fields animate__animated animate__fadeInUp animate__delay-2s">
                <span><i class="fa-solid fa-lock"></i></span>
                <input type="password" name="password" value="" v-model="password" placeholder="s3cretp@ssword"/>
            </div>
            <div class="main-action-box w-login-hide">
              <div class="w-form-control animate__animated animate__fadeInUp animate__delay-3s">
                <router-link :to="{name: 'Register', params: {qr_code:qr_code, uname:username, pass:password}}" class="flex-fill" style="width:50%;">Sign Up</router-link>
                <a href="javascript:void(0)" @click="handleLoginReq" style="width:50%;">Login</a>
              </div>
              <div
                    class="
                    w-form-control
                    animate__animated animate__fadeInUp animate__delay-1s
                    "
                    v-if="login_attempts > 0"
                >
                    <router-link :to="{name: 'Forgot Password', params: {qr_code:qr_code, uname:username}}" class="flex-fill">Reset My Password</router-link>
                </div>
            </div>
            <div class="w-login-show">
              <div class="notification-block">
              </div>
            </div>
        </form>

        <!-- <div class="main-action-box w-login-hide" v-if="remote_verified && !is_logged_in">
            <div
                class="
                w-form-control
                animate__animated animate__fadeInUp animate__delay-2s
                "
            >
                <button class="flex-fill mt-0" type="button" role="button" @click="passcodeLoginPopup">
                    Have a reservation? <b>ENTER CODE</b>
                </button>
            </div>
        </div> -->

        <!-- start of sso login section -->
        <div class="main-action-box w-login-hide" v-if="remote_verified && sso_active && !is_restricted_freeplay && !is_logged_in">
            <div 
                class="
                w-form-control
                animate__animated animate__fadeInUp animate__delay-2s
                "
            >
                <router-link :to="{name: 'Register', params: {qr_code:qr_code, uname:username, pass:password}}" class="flex-fill m-0 mb-2" style="width:50%;">
                    Sign Up
                </router-link>
            </div>
        </div>

        <!-- error container -->
        <div class="w-login-show mb-5 mt-2 notification-container w-320 mx-auto">
            <div class="animate__animated animate__fadeInUp w-320" v-if="noti_class !== '' && noti_message !== ''">
                <div class="notification-block" :class="noti_class">
                    <div class="notification-message w-270">
                        <h5>{{ noti_message }}</h5>
                        <p>{{ noti_message1 !== '' ? noti_message1 : '' }}</p>
                    </div>                
                    <div class="icon-success" v-if="noti_class == 'success'"><i class="fa-solid fa-circle-check"></i></div>
                    <div class="icon-error" v-if="noti_class == 'error'"><i class="fa-solid fa-times-circle"></i></div>
                    <div class="icon-warning" v-if="noti_class == 'warning'"><i class="fa-solid fa-exclamation-circle"></i></div>
                </div>
            </div>
        </div>
    </div>
    <PlayerFooter type="" class="animate__animated animate__fadeIn animate__delay-3s outer-footer" />

    <!-- start of passcode modal -->
    <b-modal id="passcode-modal" dialog-class="admin-portal-modal" header-class="admin-portal-bg secondary px-3 py-2" hide-footer centered hide-header>
        <template #modal-title>
            Have a reservation?
            <b-icon 
            class="icon" 
            icon="calendar-circle-fill"
            >
            </b-icon> 
        </template>
        <b-overlay :show="false" rounded="lg">
            <div class="d-flex">
            <p>Please enter reservation passcode to login.</p>
            </div>
            <b-form inline @submit.stop.prevent class="m-0 p-0">
                <div class="row">
                    <div class="d-flex mb-1 col-md-12 flex-column">
                        <div class="w-form-control w-input-fields w-100 d-flex gap-0" :class="{ 'is_invalid': $v.passcode_form.code.$error }">
                            <span><i class="fa-solid fa-file"></i></span>
                            <b-form-input
                                v-model="passcode_form.code"
                                id="code-name"
                                class="mb-2 mr-sm-2 mb-sm-0 user-name bg-lightBlack border-0" 
                                :class="{ 'is-invalid': $v.passcode_form.code.$error }" 
                                placeholder="Enter passcode..." 
                                @keyup.enter="onPressPasscodeEnter" 
                                autofocus
                            ></b-form-input>
                        </div>
                    </div>
                </div>
            </b-form>
            <div class="d-flex text-center">
                <button
                    type="button"
                    class="modal-button px-5 py-2 flex-fill" 
                    @click="handlePasscodeLogin"
                >
                    Login
                </button>
            </div>

            <div
                class="w-login-show animate__animated animate__fadeInUp mt-3 mx-auto"
                v-if="passcode_class !== '' && passcode_message !== ''"
            >
            <div class="notification-block passcode-notification" :class="passcode_class">
                <div class="notification-message w-alert-290">
                    <h5>{{ passcode_message }}</h5>
                    <p>{{ passcode_message1 !== '' ? passcode_message1 : passcode_message }}</p>
                </div>
                <div class="icon-success" v-if="passcode_class == 'success'">
                    <i class="fa-solid fa-circle-check"></i>
                </div>
                <div class="icon-error" v-if="passcode_class == 'error'">
                    <i class="fa-solid fa-times-circle"></i>
                </div>
                <div class="icon-warning" v-if="passcode_class == 'warning'">
                    <i class="fa-solid fa-exclamation-circle"></i>
                </div>
            </div>
        </div>
        </b-overlay>
    </b-modal>

  </section>
</template>

<script>
import { validateRemoteQR, userMobileLogin, passcodeLogin } from "../../services/HomepageService";
import { global_config } from "@/config/config.js";
import AllTheme from "@/components/themes/AllTheme.vue";
import PlayerFooter from "@/views/player/PlayerFooter.vue";

import Vue from 'vue';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);
import { required } from 'vuelidate/lib/validators';

export default {
  name: "mobilelogin-view",
  components: { AllTheme, PlayerFooter },

  data() {
    return {
        username: "",
        password: "",
        remote_requested: false,
        remote_verified: false,
        qr_code: this.$route.params.qr_code,
        theme_file: '',
        logo_file:'',
        theme_classes : global_config.THEME_CLASSES,
        messages: global_config.MESSAGES,
        noti_class: "",
        noti_message: "",
        noti_message1: "",
        is_logged_in: false,
        login_attempts: 0,
        sso_active:0,
        sso_urls:[],
        sso_login_pressed:false,
        is_restricted_freeplay: 0,
        client_short_name: '',
        selected_button: '',
        is_paytoplay_login_active: false,
        paytoplay_login_polling: null,
        passcode_form: {
            code : ''
        },
        passcode_status: false,
        passcode_message: "",
        passcode_message1: "",
        passcode_class: "",
        passcode_polling: null,
        pod_id_key: "",
        sso_clicked: false,
    };
  },

  computed: {
    remote_session_expired_error() {
        return this.$store.getters.getMessageDetail('remote-session-expired');
    },
  },

  validations: {
    passcode_form : {
        code : {required}
    },
  },

  methods: {
    handleLoginReq() {
      if (this.password == "" || this.username == "")
        this.makeToast('generic-required-message');
      else {
        let session_id = (JSON.parse(localStorage.qr_sess_data)).session_id_key;
        userMobileLogin(session_id, this.username, this.password).then(response => {
          if(response.status){
            this.is_logged_in = true;
            this.noti_class = this.messages.success_class;
            this.noti_message = "Success! You are logged in on "+response.data.nav_name+".";
            this.noti_message1 = "Please continue from the Gamepod now.";
            // this.noti_message = response.message;
          } else {
            if(response.message == 'invalid') {
                this.login_attempts += 1;
                this.makeToast('login-invalid-error-message');
            }
            else if(response.message == 'notpro') {
                this.makeToast('login-notpro-error-message');
            }
            else if(response.message == 'notauthorized') {
                this.makeToast('login-notauthorized-error-message');
            }
            else if(response.message == 'reserved') {
                // this.makeToast('', 'warning', 'This Gamepod is currently reserved.', 'Please try another Gamepod or return at ' + response.data.reservation.stop_time);
                this.makeToast('', 'warning', 'You cannot login here right now.', 'This pod is included in an active reservation.');
            }
            else {
                this.login_attempts += 1;
                this.makeToast(response.message, this.messages.error_class, response.message);
            }
          }
        })
      }
    },

    validateQRRemoteId() {
      this.$root.$emit('live-chat-widget-hide', 'show-hide');
      validateRemoteQR(this.qr_code).then(response => {
        this.remote_requested = true;
        if(!response.status) {
          this.remote_verified = false;
          this.noti_class = this.messages.error_class;
          this.noti_message = (this.remote_session_expired_error.is_exist) ? this.remote_session_expired_error.text_head : "This remote session has expired.";
          this.noti_message1 = (this.remote_session_expired_error.is_exist) ? this.remote_session_expired_error.text_sub : "Rescan QR code to start over.";

          // check if we have theme data even in case of error
          if(Object.prototype.hasOwnProperty.call(response, 'data') && Object.prototype.hasOwnProperty.call(response.data, 'logo')) {
            this.logo_file = response.data.logo;
            this.theme_file = response.data.theme;
            this.client_name = response.data.client_name;
            this.client_short_name = response.data.client_short_name;
            this.$store.commit("setThemeLogo", response.data);
          }
        }
        else {
          this.remote_verified = true;
          if(response.message == 'remote_init') {
            this.makeToast('', this.messages.success_class, "Starting remote session with "+response.data.nav_name+".", "Please wait while the link is established...");
          }
          else {
            this.makeToast(response.message, this.messages.success_class, response.message);
          }
          localStorage.setItem('qr_sess_data', JSON.stringify(response.data));
          this.$store.commit("setThemeLogo", response.data);
          // set theme file and logo file for pod
          this.logo_file = response.data.logo;
          this.theme_file = response.data.theme;
          this.getThemeFile();
          // set sso params
          this.sso_active = response.data.sso_active;
          this.sso_urls = response.data.sso_urls;
          this.client_name = response.data.client_name;
          this.is_restricted_freeplay = response.data.restricted_freeplay;
          this.client_short_name = response.data.client_short_name;
          this.pod_id_key = response.data.pod_id_key;
        }
      })
    },

    makeToast(message_key = '', variant = "default", message, message1="", section_key="noti") {
        // search for key
        let smessage = this.$store.state.system_messages.list.find(o => o.msg_key === message_key);
        if(smessage !== null && typeof smessage !== 'undefined' && Object.prototype.hasOwnProperty.call(smessage, 'text_head')) {
            this[section_key + '_class'] = smessage.type == 'failure' ? 'error' : smessage.type;
            this[section_key + '_message'] = smessage.text_head;
            this[section_key + '_message1'] = smessage.text_sub;
        }
        else {
            this[section_key + '_class'] = variant;
            this[section_key + '_message'] = message;
            this[section_key + '_message1'] = message1;
        }
        // hide error div
        setTimeout(() => {
            this[section_key + '_class'] = "";
            this[section_key + '_message'] = "";
            this[section_key + '_message1'] = "";
        }, 5000);
    },

    getThemeFile() {
      // remove existing classes
      for(let i = 0; i < this.theme_classes.length; i++) {
        document.body.classList.remove(this.theme_classes[i]);
      }
      if(this.theme_file !== "" && this.theme_file !== null) {
        let class_name = this.theme_file+'Theme';
        document.body.classList.add(class_name);
      }
    },
    ssoLoginPressed(url) {
        this.sso_login_pressed = true;
        window.open(url, "_blank");
        setTimeout(() => {
            this.sso_login_pressed = false;
        }, 4000);
        return false;
    },
    handleModeTabsSwitch(value="") {
        if(this.is_restricted_freeplay && this.sso_active) {
            this.selected_button = this.selected_button == value ? '' : value;
            this.is_paytoplay_login_active = (this.selected_button == '' || this.selected_button != 'paytoplay') ? false : true;
            if(this.is_paytoplay_login_active) {
                this.paytoPlayLoginPolling();
            }
            else {
                clearInterval(this.paytoplay_login_polling);
            }
        }
        else if(!this.is_restricted_freeplay && this.sso_active) {
            this.selected_button = this.selected_button == value ? '' : value;
            this.is_paytoplay_login_active = false;
            clearInterval(this.paytoplay_login_polling);
        }
        else {
            this.selected_button = '';
            this.is_paytoplay_login_active = false;
            clearInterval(this.paytoplay_login_polling);
        }
    },
    paytoPlayLoginPolling() {
        let _self = this;
        clearInterval(_self.paytoplay_login_polling);
        this.paytoplay_login_polling = setInterval(() => {
            if(_self.paytoplay_login_polling) {
                let last_activity = Math.floor((new Date()).getTime() - (new Date(localStorage.getItem('last_activity'))).getTime());
                if(last_activity >= 10000) {
                    clearInterval(_self.paytoplay_login_polling);
                    setTimeout(() => {
                        _self.is_paytoplay_login_active = false;  
                        _self.username = "";
                        _self.password = "";
                        _self.selected_button = "";
                    }, 1200);
                }
            }
        }, 1000);
    },
    passcodeLoginPopup() {
        this.$bvModal.show('passcode-modal');
    },
    handlePasscodeLogin() {
        this.$v.passcode_form.$touch();
        if (this.$v.passcode_form.$invalid) {
            this.makeToast("generic-required-message", 'default', '', '', 'passcode');
        } 
        else {
            let data = this.passcode_form;
            let pod_data = JSON.parse(localStorage.qr_sess_data);
            let session_id = pod_data.session_id_key;
            passcodeLogin(session_id, data.code, 'mobile').then((response) => {
                if (response.status) {
                    if (response.data.role_id == 1) {
                        this.is_logged_in = true;
                        this.$bvModal.hide('passcode-modal');
                        this.noti_class = this.messages.success_class;
                        this.noti_message = "Success! You are logged in now.";
                        this.noti_message1 = "Please continue from the Gamepod now.";
                    }
                    else if (response.data.role_id !== 1) {
                        this.makeToast('Only players allowed to login.', this.messages.error_class, '', '', 'passcode');
                    }
                } else {
                    if(response.message == 'notpro') {
                        this.makeToast('login-notpro-error-message', this.messages.error_class, '', '', 'passcode');
                    }
                    else if(response.message == 'notauthorized') {
                        this.makeToast('login-notauthorized-error-message', this.messages.error_class, '', '', 'passcode');
                    }
                    else if(response.message == 'notregistered') {
                        this.makeToast('login-notregistered-error-message', this.messages.error_class, '', '', 'passcode');
                    }
                    else if(response.message == 'notincluded') {
                        this.makeToast('', this.messages.error_class, 'This pod is not included in this reservation.', 'If you need help finding seats, please chat with us!', 'passcode');
                    }
                    else {
                        this.makeToast(response.message, this.messages.error_class, response.message, '', 'passcode');
                    }
                }
            });
        }
    },
    passcodePopupPolling() {
        clearInterval(this.passcode_polling);
        this.passcode_polling = setInterval(() => {
            let last_activity = Math.floor((new Date()).getTime() - (new Date(localStorage.getItem('last_activity'))).getTime());
            if(last_activity > 10000) {
                this.$bvModal.hide('passcode-modal');
            }
        }, 1000);
    },
    onPressPasscodeEnter() {
        this.handlePasscodeLogin();
    },
  },

  mounted() {
    this.noti_class = this.messages.warning_class;
    this.noti_message = this.messages.remote_verifying;
    this.validateQRRemoteId();
    // check if info recieved from register page
    let params = this.$route.params;
    let is_email_transfer = false;
    let is_pass_transfer = false;
    if(Object.prototype.hasOwnProperty.call(params, "username") && params.username !== '') {
        this.username = params.username;
        is_email_transfer = true;
    }
    if(Object.prototype.hasOwnProperty.call(params, "password") && params.password !== '') {
        this.password = params.password;
        is_pass_transfer = true;
    }
    is_email_transfer, is_pass_transfer;

    // capture passcode modal close
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
        if(modalId == "passcode-modal") {
            this.passcodePopupPolling();
        }
    });
  },
  beforeDestroy () {
    clearInterval(this.paytoplay_login_polling);
  },
  watch: {
    sso_clicked(new_val) {
        if(new_val) {
            this.is_logged_in = true;
            this.noti_class = this.messages.success_class;
            this.noti_message = "Transferred to SSO login page…";
            this.noti_message1 = "Problem? Rescan QR code to start over.";
        }
    },
  },
};
</script>
<style scoped>
.w-form-control .passcode-btn:hover,
.w-form-control .passcode-btn:focus,
.w-form-control .passcode-btn:active,
.w-form-control .passcode-btn:focus-visible {
    background: none !important;
    border: none !important;
    color: #d8d8d8 !important;
    line-height: normal;
}
.admin-portal-modal .w-form-control.w-input-fields > input {
    border: 2px solid var(--client-primary) !important;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-left: 0 !important;
}
.admin-portal-modal .modal-button {
    border-color: var(--client-primary);
}
.notification-block.passcode-notification.error {
    background: #ff174499;
}
.notification-block.passcode-notification.success {
    background: #3c815f;
}
.notification-block.passcode-notification.warning {
    background: #7b742c;
}
:deep(.admin-portal-bg:is(.secondary)) {
    background: transparent;
    background-color: transparent;
}
:deep(.admin-portal-modal .modal-title) {
    color: inherit;
}
:deep(.modal-header button.close) {
    color: inherit;
    border: 1px solid;
}
:deep(.modal-backdrop) {
    opacity: 0.85;
}
.sso-disabled,
.sso-disabled:hover {
    opacity: 1;
    cursor: not-allowed;
    background: #3f3f3f;
    border: 2px solid #3f3f3f;
    color: rgb(216 216 216 / 60%);
}
</style>